import { render, staticRenderFns } from "./EMelderComponentMeldungenChatLeftUser.vue?vue&type=template&id=c518d81c&scoped=true"
import script from "./EMelderComponentMeldungenChatLeftUser.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldungenChatLeftUser.vue?vue&type=script&lang=js"
import style0 from "./EMelderComponentMeldungenChatLeftUser.vue?vue&type=style&index=0&id=c518d81c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c518d81c",
  null
  
)

export default component.exports